import {Pipe, PipeTransform} from '@angular/core';
import {DataPoint, Sentiment} from '@selpia/shared/models';

@Pipe({standalone: true, name: 'highlightSentiment'})
export class HighlightSentimentPipe implements PipeTransform {
  transform(
    value: DataPoint | undefined,
    matchingIds: number[],
  ): Sentiment {
    if (value && matchingIds.includes(value.id)) {
      return value.sentiment;
    }
    return Sentiment.Neutral;
  }
}
